import styled from 'styled-components'

export const ContentContainer = styled.div`
  padding: 0 20px 20px;
`

export const ButtonGroup = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`

export const HelperText = styled.p`
  color: #666;
  font-size: 14px;
`
